import * as yup from "yup";
export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_DOCUMENT_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required("Molimo Vas da unesete naziv"),
  documentTypeId: yup
    .string()
    .required("Molimo Vas da odaberete tip dokumenta"),
});

